import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { concatMap, filter, take, tap } from 'rxjs/operators';

import { ProfileService } from '@main-client/src/app/profile/profile.service';

import { Account } from '@libs/src/models/account.model';
import { IAppState } from '@main-client/src/app/app.state';
import { LoadProfile } from '@main-client/src/app/profile/profile-store/profile.actions';

@Injectable()
export class ProfileStoreService {
  private user = this.store.select('user');

  constructor(
    private profileService: ProfileService,
    private store: Store<IAppState>,
  ) {}

  getProfileFromStore(profileSlug: string) {
    return this.user.pipe(
      filter((userState) => !!userState),
      take(1),
      concatMap((userState: Account) => {
        const getProfileObservable = this.profileService.populate(
          profileSlug,
          userState,
        );
        if (profileSlug !== userState.slug) {
          return getProfileObservable;
        }
        getProfileObservable
          .pipe(
            tap((profile: Account) =>
              this.store.dispatch(LoadProfile(profile)),
            ),
          )
          .subscribe();
        return of(userState);
      }),
    );
  }
}
